import { useContext } from "react"
import { AppContext } from "./context"
import { useAuth0 } from '@auth0/auth0-react';
import { client } from "./delcare";



const NotFound = (props) => {

    const { ww, } = useContext(AppContext)
    const { logout } = useAuth0()

     const logoutHandler = async (e) => {

        logout({
            clientId: client,
            logoutParams: {
                returnTo: window.location.origin
            }
        })
         
    }

    if (props.revoked) {
        return (
            <div className={" d-flex flex-column gap-3 " + (ww < 400 ? "px-1 pt-4" : "p-4")}>
                <p className=" fs-2 mb-1">Account Deactivated</p>
                <p className="poppins text-secondary">Your account access has been revoked. <a href="#" onClick={logoutHandler}>exit</a></p>
            </div>
        )
    }

    return (

        <div className={" d-flex flex-column gap-3 " + (ww < 400 ? "px-1 pt-4" : "p-4")}>
            <p className=" fs-2 mb-1">404 Not Found</p>
            <p className="poppins text-secondary">This Page Does Not Exist...</p>
        </div>
    )
}

export default NotFound